// extracted by mini-css-extract-plugin
module.exports = {"learnDetailsText":"LearnDetailsText-module--learn-details-text--135nz"};